import {Validators} from '@angular/forms';

import {ComponentTypesEnum} from '../../../app/shared/enums';
import {PhoneAutocompleteControl} from '../../../app/shared/classes';

export const ContactDetailPhoneSelector = 'phone';

export const ContactDetailComponentPhoneControl = (): PhoneAutocompleteControl => {
    return new PhoneAutocompleteControl({
        name: ContactDetailPhoneSelector,
        value: null,
        placeholder: 'Phone',
        validators: [Validators.required],
        componentType: ComponentTypesEnum.PhoneAutocomplete,
        countries: [],
        floatingLabelNever: true
    });
};
